import React, { useContext } from 'react';
import Icon from '@common/assets';
import { CalendarContext } from '@components/jobs/contextWrap';
import ArrowBtnArea from './ArrowBtnArea';
import OptionArea from './OptionArea';
import SearchArea from './SearchArea';
import { LatestOpenType } from '../../index';
import Colors from '@domain/constant/colors';

import ObjectUtil from '@utils/object/util';
import classnames from 'classnames/bind';
import styles from './calendarHeader.module.scss';
const cx = classnames.bind(styles);

interface CalendarHeaderProps {
  setIsFocusDate: (focus: boolean) => void;
  setLatestOpen: (type: LatestOpenType) => void;
  setLoginModalVisible: (visible: boolean) => void;
}

const CalendarHeader = ({ setIsFocusDate, setLoginModalVisible, setLatestOpen }: CalendarHeaderProps) => {
  const { filter } = useContext(CalendarContext);

  const isAppliedFilter = !ObjectUtil.isKeysValueAllEmpty(filter.latestFilter, [
    'businessSizeTypes',
    'jobTitles',
    'locations',
    'recruitmentTypes',
  ]);

  //필터 영역 동작
  const handleOpenFilter = () => {
    setLatestOpen('FILTER');
    filter.setVisibleFilter(true);
  };

  return (
    // 상단 고정 영역
    <div className={cx('calendarHeader')}>
      {/* 필터 / 날짜 / 옵션 영역 */}
      <div className={cx('searchArea')}>
        {/* 필터 영역 */}
        <div className={cx('filterArea')}>
          {/* 필터 버튼 */}
          <a className={cx('btnFilter', { isAppliedFilter })} role="button" onClick={handleOpenFilter}>
            <Icon name="filterLight" width={24} height={24} fill={Colors.C_COOL_GRAY_80} />
            필터
          </a>

          {/* 검색 영역 */}
          <SearchArea />
        </div>

        {/* 날짜 영역 */}
        <ArrowBtnArea setIsFocusDate={setIsFocusDate} />

        {/* 옵션 영역 */}
        <OptionArea setLoginModalVisible={setLoginModalVisible} />
      </div>

      {/* 요일 영역 */}
      <div className={cx('dayArea')}>
        <div className={cx('day', 'holiday')}>일</div>
        <div className={cx('day')}>월</div>
        <div className={cx('day')}>화</div>
        <div className={cx('day')}>수</div>
        <div className={cx('day')}>목</div>
        <div className={cx('day')}>금</div>
        <div className={cx('day')}>토</div>
      </div>
    </div>
  );
};

export default CalendarHeader;
